module.exports = "    ,.--.,    \r\n  ,`,     `.  \r\n /   '.     \\ \r\n|,    _`',   |\r\n| `., `,  '. |\r\n|    '.`    `'\r\n \\     `',  / \r\n  ',      `'  \r\n    `'--'`    "


//////////////////
// WEBPACK FOOTER
// ./src/res/wheelRight.txt
// module id = 80
// module chunks = 0